var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStringIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.2,
    height: 32.6,
    viewBox: "0 0 15.2 32.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,2.2C12,1,11,0,9.8,0H5.4C4.2,0,3.3,1,3.3,2.2v2.2H12V2.2z M13,6.5H2.2C1,6.5,0,7.5,0,8.7v21.7 c0,1.2,1,2.2,2.2,2.2H13c1.2,0,2.2-1,2.2-2.2V8.7C15.2,7.5,14.2,6.5,13,6.5z M9.8,28.2H5.4c-0.6,0-1.1-0.5-1.1-1.1 c0-0.6,0.5-1.1,1.1-1.1h4.3c0.6,0,1.1,0.5,1.1,1.1C10.9,27.8,10.4,28.2,9.8,28.2z M9.8,13H8.7v1.1c0,0.6-0.5,1.1-1.1,1.1 s-1.1-0.5-1.1-1.1V13H5.4c-0.6,0-1.1-0.5-1.1-1.1c0-0.6,0.5-1.1,1.1-1.1h1.1V9.8c0-0.6,0.5-1.1,1.1-1.1s1.1,0.5,1.1,1.1v1.1h1.1 c0.6,0,1.1,0.5,1.1,1.1C10.9,12.6,10.4,13,9.8,13z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStringIcon);
export default __webpack_public_path__ + "static/media/string-icon.732bfe2abffab6988bf279a8c3e24b9a.svg";
export { ForwardRef as ReactComponent };